// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__18z_R","errors":"Errors_errors__3xFvh"};